<!--<div id="merchant" *ngIf="ready">-->
<!--  <div class="nav-symbol">-->
<!--    <header-component></header-component>-->
<!--    <component-menu class="mobile-menu-wrapper flex lg:hidden"></component-menu>-->
<!--  </div>-->
<!--  <component-notification></component-notification>-->
<!--  <cb-modal #createProfile [autostart]="false" identifier="createProfile" [closable]="false" [dismissable]="false" [escapable]="false">-->
<!--    <syndicate-profile-create-component></syndicate-profile-create-component>-->
<!--  </cb-modal>-->
<!--  <div class="page">-->
<!--    <div class="page-content">-->
<!--      <div class="desktop-fixed-nav">-->
<!--        <desktop-fixed-menu></desktop-fixed-menu>-->
<!--      </div>-->
<!--      <router-outlet></router-outlet>-->
<!--    </div>-->
<!--  </div>-->
<!--</div>-->


<div id="merchant" *ngIf="ready">
  <div class="block w-full mx-auto mb-0 mt-0 max-w-app-max-width min-h-full">
<!--    <header-component></header-component>-->
<!--    <component-menu class="mobile-menu-wrapper flex mb-4 tablet:hidden"></component-menu>-->
    <app-custom-menu class="mobile-menu-wrapper flex flex-col mb-0"></app-custom-menu>
    <div class="flex flex-row">
      <!-- Static sidebar for desktop -->
<!--      <div class="hidden tablet:flex tablet:w-72 tablet:flex-col px-0 custom-sidebar-paddings">-->
<!--        &lt;!&ndash; Sidebar component, swap this element with another sidebar if you like &ndash;&gt;-->
<!--        <div class="flex grow flex-col gap-y-5 overflow-y-auto px-1 menu-sticky">-->

<!--          <nav class="flex flex-1 flex-col">-->
<!--            <desktop-fixed-menu></desktop-fixed-menu>-->
<!--          </nav>-->
<!--        </div>-->
<!--      </div>-->

      <main class="pb-10 w-full">
        <div class="px-2 sm:px-2 lg:pr-0 lg:pl-custom-18">
          <router-outlet></router-outlet>
        </div>
      </main>
    </div>
  </div>
  <app-footer class="flex w-full p-2"></app-footer>
</div>
